import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { StringRequest } from "../../../services/StringRequest";
import { SysAdminService } from "../../../services/sysadmin.service";
import { UserGroupUpdateRequest } from "../../../services/UserGroupUpdateRequest";

@Component({
	selector: "app-usergroup-edit-user-group",
	templateUrl: "./edit-user-group.component.html",
	styleUrls: ["./edit-user-group.component.css"],
})
export class UserGroupEditUserGroupComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private sysAdminService: SysAdminService,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.AllowDistrictGroups = this.dialogConfig.data.AllowDistrictGroups;

		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.SelectedUserGroup = this.dialogConfig.data.UserGroup;

		//Load data for user group
		this.loadUserGroupData();

		//Load form data
		this.loadUserLevels();
	}

	//////////////////////////////////
	// Data
	//////////////////////////////////
	AllowDistrictGroups: boolean = false;
	SelectedUserGroup: any;
	SchoolID: any = 0;

	Code: any = "";
	Desc: any = "";

	lstUserLevels: any = [];
	SelectedUserLevel: any = 0;

	AllSchools: any = false;

	errorMessage: any = "";

	//Edit only
	OriginalCode: any = "";
	OriginalDesc: any = "";

	//////////////////////////////////

	//////////////////////////////////
	// Load Data
	//////////////////////////////////

	loadUserGroupData() {
		this.Code = this.SelectedUserGroup.UserGroupCD;
		this.OriginalCode = this.SelectedUserGroup.UserGroupCD;

		this.Desc = this.SelectedUserGroup.UserGroupDesc;
		this.OriginalDesc = this.SelectedUserGroup.UserGroupDesc;

		this.AllSchools = this.SelectedUserGroup.SchoolID == 0 ? true : false;
	}

	loadUserLevels() {
		var result = this.sysAdminService.UserLevelGetList();
		result.subscribe(
			(response) => {
				this.lstUserLevels = response;

				if (this.AllowDistrictGroups == false) {
					this.lstUserLevels = this.lstUserLevels.filter((level: any) => level.UserLevelID == 3);
				}
				this.SelectedUserLevel = this.lstUserLevels[0].UserLevelID;

				for (var z = 0; z < this.lstUserLevels.length; z++) {
					var next = this.lstUserLevels[z];

					if (next.UserLevelID == this.SelectedUserGroup.UserLevelID) {
						this.SelectedUserLevel = next.UserLevelID;
						break;
					}
				}
			},
			(error) => {}
		);
	}

	//////////////////////////////////

	//////////////////////////////////
	// Buttons
	//////////////////////////////////
	onUpdate() {
		this.errorMessage = "";

		//Error handling
		if (this.Code == undefined || this.Code == "") {
			this.errorMessage = "Enter a Code";
		}

		if (this.Code.length < 3) {
			this.errorMessage = "Code must be at least 3 characters";
		}

		if (this.Desc == undefined || this.Desc == "") {
			this.errorMessage = "Enter a Description";
		}

		if (this.Desc.length < 3) {
			this.errorMessage = "Description must be at least 3 characters";
		}

		//Code and Description must be unique
		this.CheckCode();
	}

	CheckCode() {
		let parms: StringRequest = {
			str: this.Code,
		};

		//If code was changed check that it's not in DB
		//Original code should be in DB
		if (this.Code != this.OriginalCode) {
			var result = this.sysAdminService.GroupCodeInUse(parms);
			result.subscribe(
				(response) => {
					if (response) {
						this.errorMessage = "Code already in use";
						return;
					} else {
						this.CheckDesc();
					}
				},
				(error) => {}
			);
		} else {
			this.CheckDesc();
		}
	}

	CheckDesc() {
		let parms: StringRequest = {
			str: this.Desc,
		};

		//Check Desc if changed
		if (this.Desc != this.OriginalDesc) {
			var result = this.sysAdminService.GroupDescInUse(parms);
			result.subscribe(
				(response) => {
					if (response) {
						this.errorMessage = "Description already in use";
						return;
					} else {
						this.UpdateUserGroup();
					}
				},
				(error) => {}
			);
		} else {
			this.UpdateUserGroup();
		}
	}

	UpdateUserGroup() {
		var sID = this.SchoolID;

		if (this.AllSchools == true) {
			sID = -1;
		}

		let parms: UserGroupUpdateRequest = {
			UserGroupID: this.SelectedUserGroup.UserGroupID,
			UserLevelID: this.SelectedUserLevel,
			UserGroupCD: this.Code,
			UserGroupDesc: this.Desc,
		};

		var result = this.sysAdminService.UserGroupUpdate(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "User Group was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not update the User Group",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	//////////////////////////////////
}
